import { PimProductV1StockStatusEnum } from '@redteclab/api/clients/bully'

export const productAccessorIsProductOutOfSale = (
  stockStatus: PimProductV1StockStatusEnum | null | undefined,
): boolean =>
  !stockStatus || stockStatus === PimProductV1StockStatusEnum.OutOfSale
